import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "subwayFilled"
const SubwayFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12 1.5C17.799 1.5 22.5 6.201 22.5 12V22.5H1.5V12C1.5 6.201 6.201 1.5 12 1.5M12 3C7.03 3 3 7.03 3 12V21H4.63L6.756 18.953Q6.384 18.785 6.125 18.63C5.492 18.259 5.25 17.589 5.25 17.004V9C5.25 7.758 6.255 6.75 7.499 6.75H16.502C17.745 6.75 18.75 7.758 18.75 9V17.004C18.75 17.589 18.508 18.259 17.875 18.63Q17.617 18.785 17.243 18.953L19.37 21H21V12C21 7.03 16.97 3 12 3M15.636 19.487C14.699 19.712 13.503 19.875 12 19.875S9.3 19.712 8.364 19.487L6.794 21H17.206zM7.125 15V16.5H9.75C9.75 15.672 9.078 15 8.25 15zM15.75 15C14.922 15 14.25 15.672 14.25 16.5H16.875V15zM7.499 8.25C7.085 8.25 6.75 8.585 6.75 9V12.375H11.25V8.25zM12.75 12.375H17.25V9C17.25 8.585 16.915 8.25 16.502 8.25H12.75z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default SubwayFilledIcon
